import { cn } from '../../lib/utils';

interface FieldClassOptions {
  error?: boolean;
  /** A filter field holding a value: green border and tint, so an applied filter reads as applied. Ignored when `error`. */
  active?: boolean;
}

/**
 * The bordered form-field chrome every text field and picker trigger shares
 * (`Input`, `Textarea`, `Select`, `Combobox`, `MultiCombobox`, `MultiSelect`,
 * `SearchFieldTrigger`, `CalendarPopoverButton`): shape, border, background,
 * focus ring and disabled look. Padding, height and text colour stay with the
 * caller, because they differ per field.
 *
 * Focus is `focus-visible:` everywhere. Browsers match it on a text input
 * however it was focused, so typing fields always show the ring; a button
 * trigger shows it only from the keyboard, so one that takes focus back after
 * a mouse pick does not keep a stuck ring.
 *
 * Border and background come from one tone because `cn()` is a plain join: a
 * caller adding its own `bg-*` or `border-*` would resolve by CSS order, not
 * intent.
 */
export function fieldClass({ error = false, active = false }: FieldClassOptions = {}): string {
  return cn(
    'rounded-lg border text-sm',
    'focus-visible:border-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/20',
    'disabled:cursor-not-allowed disabled:bg-bg-subtle disabled:opacity-50',
    error ? 'border-error bg-bg-primary' : active ? 'border-primary bg-primary/5 font-medium' : 'border-border bg-bg-primary',
  );
}
